<div class="dialog-header flex align-items-center justify-content-between w-full">
  <h2>
    Status componente
    <span class="text-primary">
      #{{ lockerData.externalIdentifier }}
    </span>
  </h2>
  <p-button
    mat-dialog-close
    size="small"
    icon="pi pi-times"
    severity="secondary"
    [rounded]="true"
    [text]="true"
  />
</div>
<div mat-dialog-content>
  @for (equipment of lockerData.options | keyvalue; track $index) {
    <div class="grid justify-content-between align-items-center my-2">
      @switch (equipment.key) {
        @case ("printer") {
          <p>Imprimantă</p>
        }

        @case ("scanner") {
          <p>Scanner</p>
        }

        @case ("payment") {
          <p>POS</p>
        }
      }
      <div class="p-col-4">
        <p-dropdown
          appendTo="body"
          [options]="equipment.key === 'printer' ? printerStateOptions() : stateOptions()"
          [(ngModel)]="equipment.value.state"
          placeholder="Stare"
        ></p-dropdown>
      </div>
    </div>
  }
</div>
<div class="flex align-items-center gap-2" mat-dialog-actions>
  <p-button
    label="Închide"
    mat-dialog-close
    text="true"
  ></p-button>

  <p-button
    label="Salvează"
    (click)="update()"
  ></p-button>
</div>